import React, { useState } from 'react'
import './qualification.css'

const experienceItems = [
    {
        title: 'Full Stack Developer',
        organization: 'Callby.ai',
        meta: 'Full-time | Istanbul, Turkiye | Remote',
        date: 'Aug 2025 - Present',
        points: [
            'Refactored the existing system into a layered architecture for maintainability, scalability, and separation of concerns.',
            'Built n8n workflow automations, transcript processing flows, SQL integrations, and structured JSON data pipelines.',
            'Developed RAG and knowledge-base systems with PostgreSQL and pgvector for automated routing, SMS integration, and service automation.',
            'Designed dual-agent voice systems, customer service agents, policy inquiry flows, and ticketing agents for real-world operations.'
        ],
        skills: 'Azure DevOps, ADO.NET, PostgreSQL, n8n, FastAPI, React.js, TypeScript'
    },
    {
        title: 'Full Stack Developer',
        organization: 'Arkenom Teknoloji Hizmetleri San. ve Tic. A.S.',
        meta: 'Full-time and internship | Istanbul, Turkiye | Remote',
        date: 'Dec 2024 - Aug 2025',
        points: [
            'Worked across full-stack web development during internship and full-time periods.',
            'Contributed to production features with Docker, Jira, backend services, and collaborative delivery workflows.'
        ],
        skills: 'Docker, Jira, Web Applications'
    },
    {
        title: 'Back End Developer',
        organization: 'AKEDAS Elektrik Dagitim A.S.',
        meta: 'Internship | Greater Kahramanmaras | On-site',
        date: 'Jul 2024 - Sep 2024',
        points: [
            'Developed a store web application with ASP.NET Core API and Razor Pages for inventory and user management.',
            'Used SQL Server, Entity Framework, ADO.NET, LINQ, REST APIs, and IIS deployment for internal testing.'
        ],
        skills: 'SOLID Design Principles, Visual SVN, ASP.NET Core Web API'
    },
    {
        title: 'Full Stack Developer',
        organization: 'Self Employed',
        meta: 'Freelance',
        date: 'Feb 2022 - Jun 2024',
        points: [
            'Built desktop applications and small-scale web applications for local clients.',
            'Developed Telegram bots for automation, notifications, and customer interaction.',
            'Designed workflow automations with n8n and managed projects end-to-end while studying at university.'
        ],
        skills: 'Telegram Bot Development, Desktop Apps, Automation'
    }
]

const educationItems = [
    {
        title: "Bachelor's Degree in Software Engineering",
        organization: 'Firat University',
        meta: 'Turkiye',
        date: '2021 - 2025',
        points: [
            'Built a foundation in software engineering, algorithms, data structures, object-oriented design, and full-stack development.'
        ]
    }
]

const TimelineItem = ({ item, index, isLast }) => {
    const content = (
        <div className="qualification__card">
            <h3 className="qualification__title">{item.title}</h3>
            <span className="qualification__subtitle">{item.organization}</span>
            <span className="qualification__meta">{item.meta}</span>
            <div className="qualification__calender">
                <i className="uil uil-calendar-alt"></i> {item.date}
            </div>
            <ul className="qualification__list">
                {item.points.map((point) => (
                    <li key={point}>{point}</li>
                ))}
            </ul>
            {item.skills && <p className="qualification__skills">{item.skills}</p>}
        </div>
    )

    return (
        <div className="qualification__data">
            {index % 2 === 0 ? content : <div></div>}
            <div>
                <span className="qualification__rounder"></span>
                {!isLast && <span className="qualification__line"></span>}
            </div>
            {index % 2 === 0 ? <div></div> : content}
        </div>
    )
}

const Qualification = () => {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const visibleItems = toggleState === 1 ? experienceItems : educationItems

    return (
        <section className="qualification section" id="Qualification">
            <h2 className="section__title">Experience</h2>
            <span className="section__subtitle">Professional journey</span>

            <div className="qualification__container container">
                <div className="qualification__tabs">
                    <div className={toggleState === 1 ? "qualification__button qualification-active button--flex" :
                    "qualification__button button--flex"} onClick={() => toggleTab(1)}>
                        <i className="uil uil-briefcase-alt qualification__icon"></i> Experience
                    </div>
                    <div className={toggleState === 2 ? "qualification__button qualification-active button--flex" :
                    "qualification__button button--flex"} onClick={() => toggleTab(2)}>
                        <i className="uil uil-graduation-cap qualification__icon"></i> Education
                    </div>
                </div>
                <div className="qualification__sections">
                    <div className="qualification__content qualification__content-active">
                        {visibleItems.map((item, index) => (
                            <TimelineItem
                                key={`${item.organization}-${item.date}`}
                                item={item}
                                index={index}
                                isLast={index === visibleItems.length - 1}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Qualification
